import React from 'react';

export default function TextDisplayer({ text }) {

    return (
        <div className='text'>
            {text}
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/TextDisplayer.jsx